import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IBreadcrumbSeparatorProps from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useBreadcrumbItemContext,
    useBreadcrumbContext
} from "../../context";
import {
    BreadcrumbChevronIcon,
    BreadcrumbSlashIcon
} from "../../icons";
import {
    getBreadcrumbMeasures
} from "../../stylesheet";

const BreadcrumbSeparator: FC<IBreadcrumbSeparatorProps> = ({
    customTheme: customThemeProp,
    icon: IconComponent,
    style
}) => {
    const context = useBreadcrumbContext();

    const itemContext = useBreadcrumbItemContext();

    const {
        typography,
        iconSizes,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context.customTheme);

    const measures = getBreadcrumbMeasures({
        size: context.size,
        typography,
        iconSizes,
        spaces
    });

    if(itemContext.isFirst) {
        return null;
    }

    const SeparatorIcon = IconComponent ?? (context.separator === "slash" ? BreadcrumbSlashIcon : BreadcrumbChevronIcon);

    return <View
        importantForAccessibility="no-hide-descendants"
        style={[
            style,
            stylesheet.container
        ]}
        aria-hidden={true}
    >
        <SeparatorIcon
            customColor={colors.content.icon.low}
            size={measures.iconSize}
            color="low"
        />
    </View>;
};
export default BreadcrumbSeparator;
